module.exports = __webpack_public_path__ + "img/add.867901ec.svg";